<template>
    <pdf :src="uri"></pdf>
</template>
<script>
import pdf from 'vue-pdf'
export default {
    name: 'PdfViewer',
    components: {
        pdf,
    },
    computed: {
        uri() {
            return decodeURIComponent(this.$route.query.key)
        },
    },
}
</script>